
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { __assign } from '../../../../../tslib/tslib.es6.mjs.js';
import { createElement } from 'react';
import { useHTMLProps } from '../html/use-props.mjs.js';
import { filterProps } from './utils/filter-props.mjs.js';
import { isSVGComponent } from './utils/is-svg-component.mjs.js';
import { useSVGProps } from '../svg/use-props.mjs.js';

function createUseRender(forwardMotionProps) {
    if (forwardMotionProps === void 0) { forwardMotionProps = false; }
    var useRender = function (Component, props, projectionId, ref, _a, isStatic) {
        var latestValues = _a.latestValues;
        var useVisualProps = isSVGComponent(Component)
            ? useSVGProps
            : useHTMLProps;
        var visualProps = useVisualProps(props, latestValues, isStatic);
        var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
        var elementProps = __assign(__assign(__assign({}, filteredProps), visualProps), { ref: ref });
        if (projectionId) {
            elementProps["data-projection-id"] = projectionId;
        }
        return createElement(Component, elementProps);
    };
    return useRender;
}

export { createUseRender };
//# sourceMappingURL=use-render.mjs.js.map
